import api from '../api';

import type { StarlinkContent, StarlinkHookType } from 'domains/starlink';

export const getStarlinkContent = async <T>({
  cycle,
  document,
  page,
  page_size,
  segmentations,
  slug,
  year,
}: StarlinkHookType) => {
  return (await api
    .get('/starlink/content', {
      params: { cycle, document, page, page_size, segmentations, slug, year },
    })
    .then((resp) => resp.data)) as StarlinkContent<T>;
};
